import { render } from "./DatasetCard.vue?vue&type=template&id=683c3468"
import script from "./DatasetCard.vue?vue&type=script&lang=js"
export * from "./DatasetCard.vue?vue&type=script&lang=js"
script.render = render

export default script